<template>
  <svg
      class="gm-tool-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
      focusable="false"
  >
    <g v-if="name === 'command-center'">
      <path d="M12 2.2 20.5 7v10L12 21.8 3.5 17V7z"/>
      <circle cx="12" cy="12" r="2.6"/>
      <path d="M12 2.2v6.9M18.2 15.6l-3.9-2.3M5.8 15.6l3.9-2.3"/>
    </g>

    <g v-else-if="name === 'map-editor'">
      <path d="M3.2 3.2h11.6v11.6H3.2z"/>
      <path d="M7.1 3.2v11.6M11 3.2v11.6M3.2 7.1h11.6M3.2 11h11.6"/>
      <path d="M21.4 12.9 14 20.3l-3 .7.7-3 7.4-7.4a1.2 1.2 0 0 1 1.7 0l.6.6a1.2 1.2 0 0 1 0 1.7z"/>
    </g>

    <g v-else-if="name === 'map-player'">
      <path d="M3.2 3.2h17.6v17.6H3.2z"/>
      <path d="M9.1 3.2v17.6M14.9 3.2v17.6M3.2 9.1h17.6M3.2 14.9h17.6"/>
      <circle cx="12" cy="10.2" r="2.1" fill="currentColor" stroke="none"/>
      <path d="M8.6 17.2c0-1.9 1.5-3.2 3.4-3.2s3.4 1.3 3.4 3.2z" fill="currentColor" stroke="none"/>
    </g>

    <g v-else-if="name === 'world-editor'">
      <circle cx="10.4" cy="10.4" r="7.6"/>
      <path d="M2.8 10.4h15.2"/>
      <path d="M10.4 2.8c2 2.1 3.1 4.8 3.1 7.6s-1.1 5.5-3.1 7.6c-2-2.1-3.1-4.8-3.1-7.6s1.1-5.5 3.1-7.6z"/>
      <path d="M21.5 14.6 15.9 20.2l-2.9.7.7-2.9 5.6-5.6a1.1 1.1 0 0 1 1.6 0l.6.6a1.1 1.1 0 0 1 0 1.6z"/>
    </g>

    <g v-else-if="name === 'world-map'">
      <path d="M3 6.4 9 3.9v13.7L3 20.1z"/>
      <path d="M9 3.9l6 2.5v13.7L9 17.6z"/>
      <path d="M15 6.4 21 3.9v13.7L15 20.1z"/>
    </g>

    <g v-else-if="name === 'cartograph'">
      <circle cx="12" cy="12" r="9.2"/>
      <path d="M12 4.4l2.2 5.4 5.4 2.2-5.4 2.2-2.2 5.4-2.2-5.4L4.4 12l5.4-2.2z"/>
      <circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none"/>
    </g>

    <g v-else-if="name === 'compendium'">
      <path d="M12 6.6C10.4 5 7.8 4.3 4.3 4.5v13.2c3.5-.2 6.1.5 7.7 2.1"/>
      <path d="M12 6.6c1.6-1.6 4.2-2.3 7.7-2.1v13.2c-3.5-.2-6.1.5-7.7 2.1"/>
      <path d="M12 6.6v13.2"/>
      <path d="M6.6 8.6h3M6.6 11.6h3M14.4 8.6h3M14.4 11.6h3"/>
    </g>

    <g v-else-if="name === 'templates'">
      <path d="M3.2 3.4h12.4v17.2H3.2z"/>
      <circle cx="9.4" cy="9.2" r="2.4"/>
      <path d="M5.6 17c0-2.1 1.7-3.8 3.8-3.8s3.8 1.7 3.8 3.8"/>
      <circle cx="18.6" cy="17.4" r="2.4"/>
      <path d="M18.6 13.7v1.3M18.6 19.8v1.3M22.3 17.4H21M16.2 17.4h-1.3"/>
    </g>

    <g v-else-if="name === 'journal'">
      <path d="M5.4 4.2h11.2a2.4 2.4 0 0 1 2.4 2.4v13.2H7.8a2.4 2.4 0 0 1-2.4-2.4z"/>
      <path d="M5.4 17.4a2.4 2.4 0 0 1 2.4-2.4H19"/>
      <path d="M14.4 4.2v6.4l-2.2-1.6-2.2 1.6V4.2"/>
    </g>

    <g v-else-if="name === 'calculator'">
      <path d="M5.4 2.8h13.2v18.4H5.4z"/>
      <path d="M7.9 5.6h8.2v3.2H7.9z"/>
      <path d="M8.6 12.4h.01M12 12.4h.01M15.4 12.4h.01M8.6 15.6h.01M12 15.6h.01M15.4 15.6h.01M8.6 18.4h.01M12 18.4h.01M15.4 18.4h.01" stroke-width="2.2"/>
    </g>

    <g v-else-if="name === 'impact'">
      <circle cx="12" cy="12" r="2.4" fill="currentColor" stroke="none"/>
      <path d="M7.9 16.1a5.8 5.8 0 0 1 0-8.2M16.1 7.9a5.8 5.8 0 0 1 0 8.2"/>
      <path d="M4.7 19.3a10.3 10.3 0 0 1 0-14.6M19.3 4.7a10.3 10.3 0 0 1 0 14.6"/>
    </g>

    <g v-else-if="name === 'archetypes'">
      <path d="M12 2.6 20.1 7.3v9.4L12 21.4 3.9 16.7V7.3z"/>
      <path d="M12 7.1 16.8 9.9 15.9 15.6 12 17.4 7.7 15.1 8.2 10z"/>
      <path d="M12 2.6v4.5M20.1 7.3l-3.3 2.6M15.9 15.6 12 21.4M7.7 15.1 3.9 16.7M8.2 10 3.9 7.3"/>
    </g>

    <g v-else-if="name === 'impersonate'">
      <path d="M2.6 4.6h9.6v5.6a4.8 4.8 0 0 1-9.6 0z"/>
      <circle cx="5.4" cy="7.4" r=".8" fill="currentColor" stroke="none"/>
      <circle cx="9.4" cy="7.4" r=".8" fill="currentColor" stroke="none"/>
      <path d="M11.8 13.8h9.6v5.6a4.8 4.8 0 0 1-9.6 0z"/>
      <circle cx="14.6" cy="16.6" r=".8" fill="currentColor" stroke="none"/>
      <circle cx="18.6" cy="16.6" r=".8" fill="currentColor" stroke="none"/>
    </g>

    <g v-else-if="name === 'exit'">
      <path d="M13.4 3.4H5.2v17.2h8.2"/>
      <path d="M10.2 12h10.4M17 8.4l3.6 3.6-3.6 3.6"/>
    </g>

    <g v-else>
      <circle cx="12" cy="12" r="8.8"/>
      <path d="M12 7.4v5.2M12 16.2h.01" stroke-width="2"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'GMToolIcon',
  props: {
    name: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.gm-tool-icon {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
